import { render, staticRenderFns } from "./overall-budget.vue?vue&type=template&id=05a30373&scoped=true&"
import script from "./overall-budget.vue?vue&type=script&lang=js&"
export * from "./overall-budget.vue?vue&type=script&lang=js&"
import style0 from "./overall-budget.vue?vue&type=style&index=0&id=05a30373&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a30373",
  null
  
)

export default component.exports